<template>
    <div class="container mx-auto px-4">
        <h1 class="font-serif mb-8 md:text-5xl text-2xl text-center">{{ __('Kampányok') }}</h1>

        <div class="flex items-end mb-8">
            <c-button class="bg-slate-800 ml-auto shrink-0 text-white"
                      router
                      v-bind:to="{ name : 'campaigns.create' }"
            >
                + {{ __('Új kampány') }}
            </c-button>
        </div>

        <c-data-table responsive-breakpoint="lg"
                      v-bind:data="tableData"
                      v-if="tableData.items.length > 0"
                      v-on:sort-table="sortTable"
        >
            <template v-slot:item.picture="{ item }">
                <router-link v-bind:to="{ name: 'campaigns.edit', params: { campaign: item.values.id } }">
                    <img class="max-w-32" v-bind:alt="item.values.name" v-bind:src="item.values.picture" />
                </router-link>
            </template>
            <template v-slot:item.name="{ item }">
                <router-link class="hover:decoration-dotted hover:underline"
                             v-bind:to="{ name: 'campaigns.edit', params: { campaign: item.values.id } }"
                >
                    <strong class="block text-slate-800 text-sm">{{ item.values.name }}</strong>
                    <span class="text-slate-500 text-xs">{{ item.values.description }}</span>
                </router-link>
            </template>
            <template v-slot:item.actions="{ item }">
                <div class="flex flex-col">
                    <router-link class="cursor-pointer flex hover:decoration-dotted hover:underline text-slate-800 text-xs"
                                 v-bind:to="{ name: 'campaigns.edit', params: { campaign: item.values.id } }"
                    >
                        <c-icon class="h-4 mr-2 stroke-slate-800 w-4" icon="edit-3" />
                        {{ __('Szerkesztés') }}
                    </router-link>
                    <a class="cursor-pointer flex hover:decoration-dotted hover:underline mt-2 text-slate-800 text-xs"
                       v-on:click="deletedModel = item.values.id"
                    >
                        <c-icon class="h-4 mr-2 stroke-slate-800 w-4" icon="trash-2" />
                        {{ __('Törlés') }}
                    </a>
                </div>
            </template>
        </c-data-table>

        <span class="block font-serif text-center text-2xl" v-else>{{ __('Nincs találat') }}</span>
    </div>

    <c-modal class="md:w-[450px]" v-bind:open="deletedModel !== null" v-bind:title="__('Kampány törlése')" v-on:closeModal="deletedModel = null">
        <template v-slot:body>
            <div class="py-5 text-center text-sm">
                {{ __('Biztosan törölni szeretnéd ezt a kampányt?') }}
            </div>
        </template>
        <template v-slot:footer>
            <div class="flex justify-end w-full">
                <c-button class="bg-slate-100 mr-2 text-slate-800" v-on:click="deletedModel = null">
                    {{ __('Mégsem') }}
                </c-button>

                <c-button class="bg-error text-white" v-on:click="del">
                    {{ __('Törlés') }}
                </c-button>
            </div>
        </template>
    </c-modal>
</template>

<script setup lang="ts">
    import { inject, onMounted, ref } from 'vue';
    import {
        CButton,
        CDataTable,
        CIcon,
        CModal,
    } from '@teamfurther/cinderblock';
    import CampaignRepository from '../../repositories/CampaignRepository';

    const __ = inject('__');
    const campaignRepository = new CampaignRepository();
    const deletedModel = ref(null);
    const sort = ref<string>('name');
    const tableData = ref<object>({
        columnNames: {
            picture: __('Kép'),
            name: __('Megnevezés'),
            actions: __('Műveletek'),
        },
        defaultSort: '+name',
        items: [],
        sortableColumns: ['name'],
    });

    async function del() {
        await campaignRepository.destroy(deletedModel.value);

        await getCampaigns();

        deletedModel.value = null;
    }

    async function getCampaigns() {
        const result = await campaignRepository.index({
            sort: sort.value,
        });

        tableData.value.items = result.map((campaign) => {
            return { values : campaign }
        });
    }

    async function sortTable(sortBy: string) {
        sort.value = sortBy;

        await getCampaigns();
    }

    onMounted(async () => {
        await getCampaigns();
    });
</script>
